import React, { Component } from "react";
import InfoHeader from "../containers/InfoUser";
import Menu from "../containers/Menu";
import Queue from "../containers/Queue";
import QueueNew from "../containers/QueueNew/QueueNew";
import QueueNewV2 from "../containers/QueueNew/QueueNewV2";
import QueueSlim from "../containers/QueueSlim";
import QueueSlimNew from "../containers/QueueSlimNew/QueueSlimNew";
import Crm from "../containers/Crm";
import Details from "../containers/Details";
import Attendance from "../containers/Attendance";
import History from "./HistoryCalls";
import IngDesk from "../containers/IngDesk";
import Email from "../containers/Email";
import Ticket from "../containers/Ticket";
import Reservation from "../containers/Reservation";
import Manager from "./Manager";
import Monitorias from "./Monitorias";
import AttendanceClear from "../containers/Attendance_clear";
import ChatInternalClear from "../containers/ChatInternal_clear";
import MonitoringClear from "../containers/MonitoringClear";
import ChatInternal from "../containers/ChatInternal";
import Groups from "../containers/Groups";
import GroupsSlim from "../containers/GroupsSlim";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Notifications from "../containers/Notifications";
import Groupsatd from "../containers/Groupsatd";
import InternalManager from "../containers/InternalManager";
import ToastCalling from "../containers/ToastCalling";
import ErrorMessage from "../containers/ErrorMessage";
import ScreenBlock from "../containers/ScreenBlock";
import CaptureCallModal from "../modals/CaptureCallModal";
import TimePauseModal from "../modals/TimePauseModal";
import NoteNc2Modal from "../modals/NoteNc2Modal";
import BrowserComms from "../containers/BrowserComms";
import MountTabulator from "../containers/MountTabulator";
import ManagerNew from "./ManagerNew";
import NpsPage from "./NpsPage/NpsPage";
import PlatformNps from "./PlatformNps";
import DetailsAttendanceNps from "../containers/DetailsAttendanceNps/DetailsAttendanceNps";
import { Campaigns } from "../containers/Campaigns";
import QualityAgent from "./QualityAgent/QualityAgent";
import SideContentAttendance from "./SideContentAttendance";
import DetailsV2 from "../containers/DetailsV2";
import DetailsAttendanceNpsV2 from "../containers/DetailsAttendanceNpsV2/DetailsAttendanceNpsV2";
import { sideContentAttendanceSelected } from "../actions/sideContentAttendanceSelected";
import CampaignSideContent from "./CampaignSideContent/CampaignSideContent";
import HelpSideContent from "./HelpSideContent/HelpSideContent";
import NewSideMenu from "../containers/NewSideMenu/NewSideMenu";
import InternalManagerV2 from "../containers/InternalManagerV2";
import { GroupsSlimV2, GroupsV2 } from "../containers/GroupsV2";
import MonitoriasV2 from "../containers/MonitoriasV2";
import { testConnectionWhenInSecondPlan } from "../actions";
import ManagerPerfomance from "../containers/ManagerPerfomance";
import DragableAndResizer from "./DragableAndResizer/DragableAndResizer";
import FaqDragableAndResizer from "../containers/FaqDragableAndResizer";
import ClientsWallet from "../containers/ClientsWallet";
import HistoryCalls from "./HistoryCallsV2";

const { connection_platform } = require("../services/api");

var styles = "";
let stylesCanvas = {};

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    InfoDisplay: state.infodisplay,
    StatusAgent: state.status,
    Atendimento: state.atendimento,
    ChatSimult: state.chatsimult,
    InfoUsers: state.informationusers,
    MonitoringSimult: state.monitoringsimult,
    AtdSimult: state.atdsimult,
    IsSideContentOpen: state.isSideContentOpen,
    SideContentAttendanceSelected: state.sideContentAttendanceSelected,
    IsOpenFaqDragable: state.isOpenFaqDragableReducer,
  };
};

const mapDispatchToProps = (dispatch) => ({
  SideContentAttendanceSelectedAction: (selected) => {
    dispatch(sideContentAttendanceSelected(selected));
  },
});

const handleKeyDown = (event) => {
  // Si se presiona la tecla Tab, prevenimos su comportamiento predeterminado
  if (event.keyCode === 9) {
    event.preventDefault();
  }
};

class Dashboard extends Component {
  componentDidMount() {
    // Agregar un event listener para interceptar la pulsación de teclas
    document.addEventListener("keydown", handleKeyDown);

    let interval = null;

    const handleVisibilityChange = () => {
      const isInSecondPlan = document.hidden;
      if (isInSecondPlan) {
        interval = setInterval(() => {
          testConnectionWhenInSecondPlan();
        }, 120000);
      } else {
        const hasInterval = !!interval;
        if (hasInterval) {
          clearInterval(interval);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Eliminar el event listener cuando el componente se desmonte
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      const hasInterval = !!interval;
      if (hasInterval) {
        clearInterval(interval);
      }
    };
  }

  renderSideContent(contentSelected, hasPesquisa = true) {
    if (contentSelected === "pesquisa" && !hasPesquisa) {
      this.props.SideContentAttendanceSelectedAction("detalhes");
      return <DetailsV2 displayscreen={"atendance"} />;
    }
    switch (contentSelected) {
      case "detalhes":
        return <DetailsV2 displayscreen={"atendance"} />;
      case "pesquisa":
        return <>pesquisa</>;
      case "campanhas":
        return <CampaignSideContent />;
      case "ajuda":
        return <HelpSideContent />;
      default:
        return <DetailsV2 displayscreen={"atendance"} />;
    }
  }

  renderSideContentNpsAndCallCenter(contentSelected, hasPesquisa = true) {
    switch (contentSelected) {
      case "detalhes":
        return <DetailsV2 displayscreen={"atendance"} />;
      case "pesquisa":
        return <DetailsAttendanceNpsV2 />;
      case "campanhas":
        return <CampaignSideContent />;
      case "ajuda":
        return <HelpSideContent />;
      default:
        return <DetailsV2 displayscreen={"atendance"} />;
    }
  }

  render() {
    var collumm2 = <AttendanceClear />;
    var collumm3 = "";
    var collumm4 = <QueueSlimNew />;
    // var collumm5 = <QueueNew />;
    var collumm5 = <QueueNewV2 />;
    var collumm6 = "";
    var collumm7 = <Notifications />;
    var collumm8 = <GroupsSlim />;
    var collumm9 = <Groups />;
    //var collumm10 = <ToastCalling/>;
    var collumm10 = "";
    var collumm11 = <ErrorMessage />;
    // var collumm12  = <AlertQueue />;
    var collumm13 = <ScreenBlock />;
    var collumm14 = <CaptureCallModal />;
    var collumm15 = <TimePauseModal />;
    var collumm16 = <NoteNc2Modal />;
    var collumm17 = <BrowserComms />;
    //var collumm18 = <MountTabulator />;

    const {
      VerificarUser,
      InfoDisplay,
      Atendimento,
      ChatSimult,
      InfoUsers,
      MonitoringSimult,
      IsSideContentOpen,
      SideContentAttendanceSelected,
    } = this.props;

    if (InfoDisplay.infodisplay === "Monitorias") {
      document.getElementsByTagName("BODY")[0].classList.add("page-monitoria");
    } else {
      document
        .getElementsByTagName("BODY")[0]
        .classList.remove("page-monitoria");
    }

    if (VerificarUser.length === 0) return <Redirect to="/login" />;

    if (Atendimento.length != 0) {
      collumm2 = <Attendance />;

      const isFromNps = Atendimento.nps_call;

      if (isFromNps && IsSideContentOpen) {
        collumm3 = (
          <SideContentAttendance hasPesquisa={true}>
            {this.renderSideContentNpsAndCallCenter(
              SideContentAttendanceSelected,
              true,
            )}
          </SideContentAttendance>
        );
      }
      if (!isFromNps && IsSideContentOpen) {
        collumm3 = (
          <SideContentAttendance hasPesquisa={false}>
            {this.renderSideContent(SideContentAttendanceSelected, false)}
          </SideContentAttendance>
        );
      }
      if (isFromNps && !IsSideContentOpen) {
        collumm3 = "";
      }
      if (!isFromNps && !IsSideContentOpen) {
        collumm3 = "";
      }

      collumm6 = <Crm />;
    } else {
      collumm3 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Historic") {
      // collumm2 = <History />;
      collumm2 = <HistoryCalls />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "IngDesk") {
      collumm2 = <IngDesk />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Email") {
      collumm2 = <Email />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Casos") {
      collumm2 = <Ticket />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "CarteiraDeClientes") {
      collumm2 = <ClientsWallet />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Reservas") {
      collumm2 = <Reservation />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Gestor") {
      // collumm4 = <QueueSlim/>;
      // collumm5 = <Queue/>;
      // collumm6 = <GroupsSlim/>;
      // collumm2 = <Groups screen={'Gestor'}/>;
      // collumm3 = <Manager/>

      collumm4 = <QueueSlim />;
      collumm5 = <Queue />;
      collumm6 = "";
      collumm2 = "";
      collumm3 = <Manager />;
    }

    if (InfoDisplay.infodisplay === "Gestor2") {
      collumm2 = <ManagerNew />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "NPS") {
      collumm2 = <NpsPage />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "QualityAgent") {
      collumm2 = <QualityAgent />;
      collumm3 = "";
      collumm4 = "";
      collumm5 = "";
      collumm6 = "";
    }

    if (InfoDisplay.infodisplay === "Equipes") {
      // collumm4 = <InternalManager/>
      // collumm6 = '';
      // collumm5 = '';
      // collumm3 = '';
      // collumm2 = '';

      // collumm4 = <QueueSlim />;
      // collumm5 = <Queue />;
      collumm4 = <QueueSlimNew />;
      // collumm5 = <QueueNew />;
      collumm5 = <QueueNewV2 />;
      collumm6 = <InternalManagerV2 />;
      collumm3 = InfoUsers.supervisor === true ? <ManagerPerfomance /> : "";
      collumm2 = "";
    }

    if (InfoDisplay.infodisplay === "Atendentes") {
      if (ChatSimult.length != 0) {
        collumm2 = <ChatInternal />;
      } else {
        collumm2 = <ChatInternalClear />;
      }
      collumm3 = "";
      collumm5 = "";
      collumm6 = <Groupsatd />;
      collumm4 = "";
    }

    if (InfoDisplay.infodisplay === "Arquivos") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = "";
    }

    if (InfoDisplay.infodisplay === "Monitorias") {
      if (MonitoringSimult.length != 0) {
        // collumm3 = <Monitorias />;
        collumm3 = <MonitoriasV2 />;
      } else {
        collumm3 = <MonitoringClear />;
      }
      collumm4 = "";
      collumm5 = "";

      if (connection_platform.screngroupmonitoring) {
        collumm6 = <GroupsSlimV2 />;
        collumm2 = <GroupsV2 screen={"Monitorias"} />;
        // collumm2 = <Groups screen={"Monitorias"} />;
      } else {
        collumm6 = "";
        collumm2 = "";
      }
    }

    if (InfoDisplay.infodisplay === "PlatformNps") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = <PlatformNps />;
    }

    if (InfoDisplay.infodisplay === "Campanhas") {
      collumm2 = "";
      collumm3 = "";
      collumm5 = "";
      collumm6 = "";
      collumm4 = <Campaigns />;
    }

    if (InfoUsers.blockscreen === true) {
      styles = {
        filter: "blur(4px)",
        userselect: "none",
        height: "100vh",
        overflow: "hidden",
      };
    } else {
      styles = {};
    }

    if (
      InfoDisplay.infodisplay === "Equipes" ||
      InfoDisplay.infodisplay === "Clientes"
    ) {
      stylesCanvas = {
        padding: "10px 10px 0",
      };
    } else {
      stylesCanvas = {};
    }

    return (
      <React.Fragment>
        <InfoHeader />
        <div className="stage" style={styles}>
          <div id="drawer-portal-root"></div>
          <NewSideMenu />
          <div className="canvas" style={stylesCanvas}>
            {collumm4}
            {collumm5}
            {collumm6}
            {collumm2}
            {collumm3}
            {collumm7}
            {collumm10}
            {collumm11}
            {collumm14}
            {collumm15}
            {collumm16}
            {collumm17}
            {/* {collumm18} */}
          </div>
          {Boolean(this.props.IsOpenFaqDragable) &&
            this.props.IsOpenFaqDragable.isOpen && <FaqDragableAndResizer />}
        </div>
        {collumm13}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
